import styled from 'styled-components';

export const FilterBlock = styled.div`
  text-align: center;

  h2 {
    margin-bottom: 45px;
    color: #4a4a4a;
    font-size: 30px;
    line-height: 40px;

    @media (max-width: 767px) {
      font-size: 20px !important;
      line-height: normal !important;
    }
  }
`;

export const UlFilterMenu = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  &[dir='ltr'] {
    li + li {
      margin-left: 30px;
    }
  }

  &[dir='rtl'] {
    li {
      @media (max-width: 767.98px) {
        margin-right: 30px;
      }
    }
    li + li {
      margin-right: 30px;
    }
  }
`;

export const FilterOption = styled.div``;

export const LiFilterMenu = styled.li`
  max-width: calc(33.333% - 38px);
  background: #fff;
  border: 1px solid #ebebeb;
  letter-spacing: 0;
  text-align: center;
  width: 100%;
  vertical-align: middle;
  margin-bottom: 30px;
  display: inline-block;
  transition: 0.3s ease all;
  cursor: pointer;

  @media (max-width: 991px) {
    max-width: calc(50% - 30px);
  }

  @media (max-width: 767px) {
    max-width: calc(50% - 20px);
    margin-bottom: 5px;
    margin-left: 10px !important;
  }

  &:nth-child(2n + 3) {
    @media (max-width: 991px) {
      margin-left: 0;
    }
  }

  &.active {
    border: 1px solid #1b7bdd;
  }

  a {
    color: #000;
    padding: 0 15px;
    line-height: 25px;
    min-height: 85px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-size: 20px;
    text-transform: capitalize;

    @media (max-width: 767px) {
      font-size: 14px;
      min-height: auto;
      padding: 12px 5px;
      line-height: normal;
      display: block;
    }
  }
`;

export const StickySidebarColumnTwo = styled.div`
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  @media (min-width: 768px) {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  &.sticky_top {
    @media (max-width: 767.98px) {
      padding-left: 0px;
      padding-right: 0px;
      position: sticky !important;
      top: 0;
      z-index: 9;
      background: #fff;
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(137, 137, 137, 0.3);
      margin-bottom: 20px;
    }
  }
`;

export const StickySidebar = styled.div`
  position: sticky;
  top: 0px;
  height: 100%;
`;

export const Sidebar = styled.div`
  height: 100%;
  position: relative;
  padding-bottom: 0;

  @media (max-width: 1024px) {
    padding-bottom: 0;
  }
  @media (max-width: 768px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const TimeDistanceWrapper = styled.div`
  @media (min-width: 768px) {
    position: sticky;
    top: 10rem;
    margin-bottom: 2.5rem;
  }

  @media (max-width: 1099px) {
    top: 0px;
    position: sticky;
  }
`;

export const TimeBlock = styled.div`
  font-size: 48px;
  color: #000;
  text-transform: capitalize;
  line-height: normal;

  time {
    text-transform: uppercase;
    display: ${({ dir }) => (dir === 'rtl' ? 'block' : '')};
  }

  span {
    font-size: 40px;
    position: relative;
    margin-top: 20px;
    padding-top: 16px;
    display: inline-block;

    @media (max-width: 991.98px) {
      font-size: 22px;
    }

    @media (max-width: 767px) {
      font-size: 16px !important;
      margin-top: 4px;
      padding-top: 0;
    }

    &:before {
      content: '';
      width: 70%;
      height: 1px;
      background: #1b7bdd;
      position: absolute;
      top: 0;

      @media (max-width: 767px) {
        display: none;
      }
    }

    &[dir='ltr'] {
      left: 0;
    }

    &[dir='rtl'] {
      right: 0;
    }
  }

  @media (max-width: 767px) {
    font-size: 20px;
    float: left;
    display: inline-grid;
  }
`;

export const SectionPagination = styled.div`
  margin-top: 80px;

  @media (max-width: 1280px) {
    margin-top: 120px;
  }

  @media (max-width: 1366px) {
    margin-top: 100px;
  }

  @media (max-width: 767px) {
    float: right;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const ULPagination = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  @media (max-width: 767.98px) {
    display: flex;
  }
`;

export const LiPagination = styled.li`
  margin-bottom: 1.5rem;

  button {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #f7f7f7;
    font-size: 12px;
    color: #9b9b9b !important;
    text-align: center;
    border-radius: 50px;
    text-decoration: none;
    transition: 0.3s ease all;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    &.arrow_btn:last-child {
      &[dir='ltr'] {
        padding-left: 14px;
      }

      &[dir='rtl'] {
        padding-right: 14px;
      }
    }

    &[dir='ltr'] {
      .arrow {
        left: 0;
      }
    }

    &[dir='rtl'] {
      .arrow {
        right: 0;
        transform: scaleX(-1) translateY(-50%);
      }
    }

    .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 15px;
      width: 15px;
    }

    &:hover {
      background: #1b7bdd;
      color: #fff !important;
      text-decoration: none;
    }
  }

  @media (max-width: 767px) {
    margin-left: 15px;
  }
`;

export const ContentBlock = styled.div`
  margin-bottom: 30px;
  width: 100%;
  height: auto;
  display: none;

  &.active-content {
    display: block;
  }
`;

export const TwoColumnBlock = styled.div`
  min-height: 384px;
  margin-bottom: 30px;
  padding-right: 15px;
  padding-left: 15px;
`;

export const BlockImage = styled.div`
  background-color: #b2b2b2;
  width: 100%;
  height: 100%;
  span {
    width: 100%;
    height: 100%;
    display: block !important;
  }

  img {
    width: 100%;
    position: relative;
    z-index: 1;
    height: 384px !important;
    object-fit: cover;
    font-family: 'object-fit: cover;';
  }

  @media (max-width: 991px) {
    margin-bottom: 30px;
  }
`;

export const CardWrapper = styled.div``;

export const FilterCard = styled.div`
  border: 0;
  background: 0 0;
  border-radius: 0;
`;

export const CardHeader = styled.div`
  padding: 0;
  border: 0;
  background-color: transparent;

  span {
    font-size: 10px;
    line-height: 15px;
    letter-spacing: 1.82px;
    color: #000;
    text-transform: uppercase;
    margin-bottom: 15px;
    display: inline-block;
  }

  h3 {
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 30px;
    color: #000;

    @media (max-width: 1199.98px) {
      font-size: 18px;
    }

    @media (max-width: 767.98px) {
      font-size: 16px;
    }

    @media (max-width: 767px) {
      font-size: 18px !important;
      line-height: normal !important;
    }
  }
`;

export const CardBody = styled.div`
  padding: 0;

  h4 {
    color: #4a4a4a;
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 22px;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GEAwtarDWTCMedium,serif' : 'DINRegular ')};
    font-weight: 400;
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};

    @media (max-width: 1199.98px) {
      font-size: 16px;
    }

    @media (max-width: 767px) {
      font-size: 16px !important;
      line-height: normal !important;
    }
  }

  p {
    color: #898989;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
  }
`;

export const ButtonCard = styled.div`
  margin-top: 30px;

  a {
    text-decoration: none;
    color: #1b7bdd;
    display: inline-block;
    transition: 0.3s ease all;
    font-size: ${({ dir }) => (dir === 'rtl' ? '12px' : '10px')};
    line-height: 16px;
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.82px')};
    text-transform: uppercase;

    &:hover {
      text-decoration: underline !important;
      color: #165ca3 !important;
    }
  }

  a + a {
    margin-left: ${({ dir }) => (dir === 'rtl' ? '' : '20px')};
    margin-right: ${({ dir }) => (dir === 'rtl' ? '20px' : '')};
  }
`;

export const ButtonCardLM = styled.div`
  margin-top: 30px;

  a {
    text-decoration: none;
    color: #1b7bdd;
    display: inline-block;
    transition: 0.3s ease all;
    font-size: ${({ dir }) => (dir === 'rtl' ? '12px' : '10px')};
    line-height: 16px;

    &[dir='ltr'] {
      letter-spacing: 1.82px;
      text-transform: uppercase;
    }

    &:hover {
      text-decoration: underline !important;
      color: #165ca3 !important;
    }
  }
`;

export const OneColumnBox = styled.div``;

export const CardWrapperOne = styled.div`
  border: 1px solid #d8d8d8;
  position: relative;
  overflow: hidden;
  height: 384px;
  margin-bottom: 30px;

  .accordion-title {
    bottom: 20px;
    transition: all 0.3s;

    &.open {
      bottom: calc(100% - 90px);
    }
  }

  &.card_minhgt_cmpus {
    height: 535px;

    @media (max-width: 767px) {
      height: auto;
      min-height: 335px;
    }
    .block_img_Hgt {
      height: 384px !important;
      @media (max-width: 767.98px) {
        height: auto !important;
      }
      img {
        height: auto !important;
        @media (max-width: 767.98px) {
          height: 384px !important;
        }
      }
    }
  }
`;

export const CardOneColumn = styled.div`
  border: 0;
  position: absolute;
  top: calc(100% - 120px);
  padding: 30px;
  left: 0;
  height: 100%;
  width: 100%;
  background: #fff;
  z-index: 1;
  transition: top 0.3s ease-in-out 0s;
  border-radius: 0;

  @media (max-width: 991.98px) {
    top: calc(100% - 110px);
  }

  @media (max-width: 576px) {
    top: calc(100% - 110px);
  }

  &.active {
    top: 0 !important;

    p {
      opacity: 1;
    }
    h3 {
      overflow: visible;
      height: auto;
    }

    .crd_bdy_clm,
    .onecolumn_card {
      opacity: 1;
    }

    &.cmpus_crd_clm {
      @media (max-width: 767px) {
        margin-top: -390px;
        position: relative;
      }

      @media (max-width: 575px) {
        margin-top: -390px;
      }
    }
  }

  &.cmpus_crd_clm {
    top: calc(100% - 245px);
    transition: top 0.3s ease-in-out 0s;

    @media (max-width: 767px) {
      padding-top: 25px;
      top: 220px;
      height: auto;
      min-height: 100%;
    }

    @media (max-width: 575px) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  &.collapsed {
    p {
      opacity: 0;
    }
  }
`;

export const CardOneColumnSec = styled.div``;

export const CardOneHeader = styled.div`
  position: relative;
  padding: 0;
  border: 0;
  background-color: transparent;

  span {
    font-size: 10px;
    line-height: 15px;
    color: #000;
    text-transform: uppercase;
    margin-bottom: 15px;
    display: inline-block;

    &[dir='ltr'] {
      letter-spacing: 1.82px;
    }
  }

  h3 {
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 30px;
    color: #000;
    overflow: hidden;
    height: 35px;

    @media (max-width: 1199px) {
      font-size: 14px !important;
      margin-bottom: 15px;
    }
    @media (max-width: 767.98px) {
      line-height: 20px;
    }

    &[dir='ltr'] {
      padding-right: 10px;
    }

    &[dir='rtl'] {
      padding-left: 10px;
    }
  }
  &.campus_card_header {
    h3 {
      @media (max-width: 767px) {
        line-height: normal !important;
      }
      @media (max-width: 575px) {
        &[dir='ltr'] {
          padding-right: 30px;
        }

        &[dir='rtl'] {
          padding-left: 30px;
        }
      }
    }
  }
`;

export const CardBodyOneColumn = styled.div`
  padding: 0;
  max-width: 95%;
  &.onecolumn_card {
    opacity: 0;
  }
  h4 {
    color: #4a4a4a;
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 22px;
    font-weight: 400;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GEAwtarDWTCMedium,sans-serif' : 'DINRegular')};
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '0' : '1.29px')};

    @media (max-width: 1199px) {
      font-size: 16px !important;
    }

    @media (max-width: 991px) {
      font-size: 14px !important;
      margin-top: 0px;
    }
    @media (max-width: 767px) {
      font-size: 16px !important;
      margin-top: 0px;
    }
  }

  p {
    color: #898989;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
    transition: 0.3s opacity;
  }

  &.crd_bdy_clm {
    max-width: 100%;

    @media (max-width: 767.98px) {
      opacity: 0;
    }
    h4 {
      @media (max-width: 767px) {
        font-size: 14px !important;
      }
    }
  }
`;

export const BlockCardImage = styled.div`
  height: calc(100% - 120px);
  position: relative;
  z-index: 1;
  box-sizing: border-box;

  &.block_img_Hgt {
    height: auto;
  }

  .lazy-load-image-background {
    display: block !important;
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 384px !important;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    height: 220px;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  object-fit: contain;
`;

export const ToggleTag = styled.div`
  bottom: 35px;
  cursor: pointer;
  position: absolute;
  z-index: 9;
  left: 0;
  width: 100%;
  height: 36px;

  &:after {
    content: '';
    transform: rotate(225deg);
    width: 10px;
    height: 10px;
    border: solid #000;
    border-width: 0 2px 2px 0;
    display: inline-block;
    z-index: 9;
    position: absolute;
    top: 15px;
    transition: all 0.5s;
  }

  &[dir='ltr'] {
    &:after {
      right: 30px;
    }
  }

  &[dir='rtl'] {
    &:after {
      left: 30px;
    }
  }

  &.open {
    &:after {
      top: 11px;
      transform: rotate(45deg);
    }
  }
`;

export const BackToTop = styled.div`
  cursor: pointer;
  position: absolute;
  bottom: 0px;

  a {
    font-size: 10px;
    color: #1b7bdd;
    text-transform: uppercase;
    line-height: 16px;
    text-decoration: underline;
  }

  span {
    font-size: 13px;
    color: #1b7bdd;
  }

  @media (max-width: 768px) {
    display: none;
  }

  &[dir='ltr'] {
    a {
      letter-spacing: 1.82px;
      margin-right: 5px;
    }
  }

  &[dir='rtl'] {
    a {
      margin-left: 5px;
    }
  }
`;

export const BackToTopCampus = styled.button`
  cursor: pointer;
  width: fit-content;
  background-color: transparent;
  border: none;
  outline: none;
  font-family: inherit;

  @media (max-width: 575px) {
    display: none;
  }
`;

export const BackToTopLabel = styled.span`
  font-size: 10px;
  color: #1b7bdd;
  text-decoration: underline;
  margin-right: 0.5rem;

  &[dir='ltr'] {
    letter-spacing: 1.82px;
    text-transform: uppercase;
  }
`;

export const BackToTopArrow = styled.span`
  font-size: 13px;
  color: #1b7bdd;
  text-decoration: none;
`;
